/**
 * 大事记列表
 */
import request from '../request'
const bigEventApi = {}

/**
 * 大事记列表 /function/events/list
 */
bigEventApi.eventList = param => {
  return request({
    url: '/function/events/list',
    method: 'GET',
    params: param
  })
}

/**
 *  获取年限下拉列表数据
 */
bigEventApi.getYearSelect = () => {
  return request({
    url: '/function/events/selectYear',
    method: 'GET'
  })
}

/**
 * 新建大事记
 */
bigEventApi.addBigEvent = param => {
  return request({
    url: '/function/events',
    method: 'POST',
    data: param
  })
}

/**
 * 根据id 查询详情
 */
bigEventApi.queryDetailById = param => {
  return request({
    url: '/function/events',
    method: 'GET',
    params: param
  })
}

/**
 * 删除大事记
 */
bigEventApi.deleteBigevent = param => {
  return request({
    url: '/function/events/remove',
    method: 'POST',
    data: param
  })
}

/**
 * 修改大事记
 */
bigEventApi.updateBigEvent = param => {
  return request({
    url: '/function/events',
    method: 'PUT',
    data: param
  })
}

export default bigEventApi
